module.exports = __webpack_public_path__ + "img/SOKAL-SRS-112321-DealerDraftMazda-Lifestyle1.98a3d11d.jpeg";